import { ReactNode, useCallback } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import { CommonErrorFallback } from '~/errors/fallbacks/CommonErrorFallback';
import { reload } from '~/utils/reload';

type Props = {
  children: ReactNode;
};

export const RootErrorBoundary = ({ children }: Props) => {
  const handleError = useCallback(
    (error: Error, info: { componentStack: string }) => {
      console.error(error, info.componentStack);
      // TODO: sentry error 처리
    },
    []
  );

  return (
    <ErrorBoundary
      FallbackComponent={CommonErrorFallback}
      onError={handleError}
      onReset={reload}
    >
      {children}
    </ErrorBoundary>
  );
};
